import SelectInput from "../shared/Inputs/SelectInput";
import { TextInput } from "../shared/Inputs/TextInput";

interface HiddenPageFormProps {
  title: string;
  description: string;
  register: any;
  setValue: any;
  watch: any;
  schema: any;
}

export default function HiddenPageForm({title, description, register, setValue, watch, schema}: HiddenPageFormProps) {
  return (
    <div className="border-t pt-4 space-y-4">
      <div>
        <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
        <p className="text-xs text-gray-500 mt-1">
          {description}
        </p>
      </div>

      {schema.map((field: any) => {
        switch (field.type) {
          case "text":
            return (
              <TextInput
                key={field.key}
                label={field.label}
                register={register}
                registerName={`defaults.${field.key}`}
              />
            );
          case "select":
            return (
              <>
                <SelectInput
                  key={field.key}
                  label={field.label}
                  register={register}
                  registerName={`defaults.${field.key}`}
                  options={field.options ?? []}
                  setValue={setValue}
                  watch={watch}
                />
                {field.toggleableOptions && field.options.map((option: any) => (
                  <div key={option.value} className="mt-2 ml-4">
                    <label className="inline-flex items-center">
                      <input
                        type="checkbox"
                        className="form-checkbox h-4 w-4 text-primary-600"
                        {...register(`defaults.exclude.${field.key}.${option.id}`)}
                      />
                      <span className="ml-2 text-sm text-gray-700">
                        Exclude option "{option.name}" in selection
                      </span>
                    </label>
                  </div>
                ))}
              </>
              
            );
          default:
            return null;
        }
      })}
    </div>
  )
}